<template>
    <div class="body-category-delete">
        <img src="../../../assets/images/Public/img-delete.png" alt="">
        <div class="border-category-delete">
            <div class="text-title">删除分类</div>
            <div class="text-tip">确定要删除分类吗？</div>
            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CategoryDelete",
    data(){
        return {
            moduleTitle: "",
            title: "",
        }
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.title);
            this.close();
        }
    },

}
</script>

<style scoped>
div.body-category-delete{
    width: 4.72rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 30vh auto;
}
div.body-category-delete img{
    width: 1.55rem;
    height: 1.03rem;
    display: block;
    margin: -1.11rem auto 0.08rem;
}
div.border-category-delete{
    width: 100%;
    height: auto;
    padding: 0.2rem 0.16rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}

div.text-title{
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.26rem;
    text-align: center;
}
div.text-tip{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
    margin-top: 0.16rem;
}


div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>